<template>
  <div>
    <div class="enter">
      <!-- 1.金融服务 -->
      <div class="right">
        <img
          style="height: 320px; width: 100%; overflow: hidden"
          src="../../assets/jrfw.png"
          alt=""
        />
      </div>
    </div>
    <!-- 导航 -->
    <navigate :daohangshuju="daohangshuju" />

    <div class="product contentCss">
      <div class="text">
        <h4>供应链金融</h4>
        <p>
          电力行业作为一个资金密集型行业，供货周期相对较长，对供应链金融服务需求明显。通过对整体供应链体系的大数据信用分析及专业的风控建模，为体系类的中小企业解决融资需求及提供金融产品。
          <el-link
            type="primary"
            :underline="false"
            href="http://bizfront.cecdlzx.com/?cp=PRD_2mr748nj"
            target="_blank"
            ><span class="licxCss">立即查询>></span></el-link
          >
        </p>
      </div>
      <div class="text">
        <h4>保函业务</h4>
        <p>
          为完善电子采购平台生态招投标及企业项目各环节所需保证金、保险提供管理及业务服务全流程综合解决方案。
        </p>
      </div>
      <div class="text">
        <!-- <h4>保函业务</h4> -->
        <p>
          保函管理服务信息化系统平台，聚焦招标采购场景，服务于政府、央国企采购领域的招投标企业，以电子保函替代现金保证金，具有减少企业现金流占用、风险可控、降低费率等特点，助力优化营商环境。实现从保前到保后的全流程闭环服务支撑。
        </p>
      </div>
      <div class="text">
        <!-- <h4>保函业务</h4> -->
        <p>
          与专业电子保函服务主体合作，具备完善的技术团队，将服务软件系统嵌入到采购交易平台，完成从勘察设计、招标投标、项目施工、竣工验收等全周期一体化系统解决方案。
          <el-link
            type="primary"
            :underline="false"
            href="https://dlzx.zjbaohan.com/index"
            target="_blank"
            ><span class="licxCss">查看详情>></span></el-link
          >
        </p>
      </div>
    </div>
    <!-- <div class="daohangjianjie contentCss">
      <div class="threeBox">
        <div class="text">
          <h4>平台服务</h4>
          <p>
            保函管理服务信息化系统平台，聚焦招标采购场景，服务于政府、央国企采购领域的招投标企业，以电子保函替代现金保证金，具有减少企业现金流占用、风险可控、降低费率等特点，助力优化营商环境。实现从保前到保后的全流程闭环服务支撑。
          </p>
        </div>
        <div class="text">
          <h4>专业资质</h4>
          <p>
            与专业电子保函服务主体合作，具备完善的技术团队，将服务软件系统嵌入到采购交易平台，完成从勘察设计、招标投标、项目施工、竣工验收等全周期一体化系统解决方案。
          </p>
        </div>
      </div>
    </div> -->
    <!-- <div class="xdcSearch">
      <el-link type="primary" :underline="false" href="" target="_blank"
        >信电查入口</el-link
      >
    </div> -->
  </div>
</template>

<script>
import xdcPng from '@/assets/xdc.png'
import ckPng from '@/assets/logo.png'
import srcImg from '@/assets/xdc1.png'
import HoverImage from "@/components/HoverImage/index"
// 导航组件
import navigate from '@/components/navigate'
export default {
  name: 'vuecomponent',
  components: {
    HoverImage,
    navigate
  },
  data () {
    return {
      xdcPng: xdcPng,
      ckPng,
      searchInput: '',
      bannerList: [
        {
          id: 1,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/257f8ab88f9445b98f9c2826c3203e45.png',
          url: "https://www.cecdlzx.com/owms/#/home"
        },
        {
          id: 2,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/576e0a8c10f1459797aced9ca904efd1.png',
          url: "https://www.cecdlzx.com/dlzx/#/electric"
        },
        {
          id: 3,
          content: 'https://www.cecdlzx.com/oss/owms/26E5A26B9230CD01A4B1A1C44EC225BD/77b7d0be5ebc43ad94854b7863386d4c.png',
          url: "https://www.cecdlzx.com/dlzx/#/login"
        },
      ],
      key: "value",
      srcImg,
      daohangshuju: '金融服务',
    }
  }
}
</script>

<style lang="less" scoped>
.bannerImg {
  height: 260px;
}

.text1 {
  padding: 0 10px;
}
.product {
  .h3Text {
    font-size: 24px;
    font-weight: 400;
    text-align: center;
    color: rgba(58, 58, 74, 1);
    margin-top: 30px;
  }
  .text {
    // margin: 15px;
    padding: 10px;
    h4 {
      color: #005ba3;
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 16px;
    }
    p {
      margin: 0 0 5px;
      line-height: 24px;
    }
  }
}

.partner {
  // margin: 10px 0;

  .title {
    text-align: center;
    position: relative;

    p {
      font-size: 48px;
      font-weight: bold;
      color: rgba(153, 154, 155, 0.3);
    }

    h2 {
      font-size: 36px;
      position: absolute;
      margin: 0;
      left: 45%;
      top: 35px;
    }
  }

  .list {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    span {
      width: 150px;
      height: 60px;
    }
  }
}

.enter {
  overflow: hidden;
  position: relative;
  // padding: 10px;
  width: 100%;
  height: 350px;
  .right {
    width: 100%;
  }
  .last {
    margin-left: 80px;
    width: 100%;
    position: absolute;
    top: 260px;
    .smallBox {
      font-size: 16px;
      width: 180px;
      height: 50px;
      color: #fff;
      border-radius: 5px;
      padding: 10px;
      text-align: center;
      line-height: 45px;
      height: 60px;
      border: 2px solid #53aee7;
      background: #53aee7;
      box-shadow: 0 1px 1px #53aee7, 0 2px 2px #53aee7, 0 3px 3px #53aee7,
        0 4px 4px #53aee7, 0 5px 5px #53aee7;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
    }
  }
}
.smallBox:hover {
  /* 鼠标移动上去后  */
  transform: scale(1.2, 1.2);
}
.xdcSearch {
  margin: 10px auto;
  height: 45px;
  line-height: 45px;
  border-radius: 5px;
  text-align: center;
  border: 1px solid #53aee7;
  width: 150px;
}

.daohangjianjie {
  // margin-top: 60px;
  // margin-bottom: 60px;
  .h3Text {
    font-size: 30px;
    font-weight: 400;
    text-align: center;
    color: rgba(58, 58, 74, 1);
    margin-top: 30px;
  }
  .threeBox {
    display: flex;
    justify-content: space-around;
    .text {
      margin: 30px;
      position: relative;
      flex: 1;
      color: rgba(58, 58, 74, 1);
      box-shadow: 0px 1px 4px 0px rgba(0, 120, 255, 0.2);
      border-radius: 4px;
      padding: 12px;
      transform-origin: 50% 50%;
      /* 设置过渡动画 */
      transition: all 1s;
      h4 {
        // margin-top: 40px;
        margin-bottom: 20px;
        font-weight: 700;
        font-size: 16px;
        text-align: center;
      }
      p {
        margin: 0 0 10px;
        line-height: 24px;
      }
      .DetailBtn {
        margin-top: 20px;
        text-align: center;
      }

      .titleImg,
      .titleImg1 {
        padding: 10px;
        border: 1px solid #409eff;
        border-radius: 50%;
        position: absolute;
        top: -35px;
        left: 43%;
      }
    }
    .text:hover {
      /* 鼠标移动上去后  */
      transform: scale(1.1, 1.1);
      background-color: #e8f0fe;
    }
  }
}
</style>
